<template>
  <KkOptionItemLayout
    class="kk-option-item"
    :input-position="inputPosition"
  >
    <template #input>
      <slot name="input" />
    </template>
    <template #input-label>
      <label
        class="kk-option-item__label"
        :for="id"
      >
        <KkOptionItemIconLayout :icon-position="iconPosition">
          <template
            v-if="label"
            #label
          >
            <KkOptionItemLabel
              :label="label"
              :size="size"
              :is-disabled="isDisabled"
              :is-required="isRequired"
            />
          </template>
          <template
            v-if="description"
            #description
          >
            <KkOptionItemDescription
              :description="description"
              :is-disabled="isDisabled"
            />
          </template>
          <template
            v-if="iconName || imageSrc"
            #icon
          >
            <KkOptionItemIcon
              :icon-name="iconName"
              :icon-size="iconSize"
              :image-src="imageSrc"
              :image-alt="imageAlt"
              :is-disabled="isDisabled"
            />
          </template>
        </KkOptionItemIconLayout>
      </label>
    </template>
    <template
      v-if="$slots.children"
      #children
    >
      <slot name="children" />
    </template>
    <template
      v-if="$slots.footer"
      #footer
    >
      <slot name="footer" />
    </template>
  </KkOptionItemLayout>
</template>

<script>
import KkOptionItemLayout from '../../KkOptionItemLayout';
import KkOptionItemIconLayout from '../../KkOptionItemIconLayout';
import KkOptionItemLabel from '../../KkOptionItemLabel';
import KkOptionItemDescription from '../../KkOptionItemDescription';
import KkOptionItemIcon from '../../KkOptionItemIcon';

const OPTION_SIZE_LIST = ['md', 'lg'];
const INPUT_POSITION_LIST = ['left', 'right'];
const ICON_POSITION_LIST = ['left', 'right', 'top-right'];
const ICON_SIZE_MAP = {
  md: 'sm',
  lg: 'md',
};

export default {
  name: 'KkOptionItem',
  components: {
    KkOptionItemLayout,
    KkOptionItemIconLayout,
    KkOptionItemLabel,
    KkOptionItemDescription,
    KkOptionItemIcon,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    inputPosition: {
      type: String,
      default: 'left',
      /** @param {string} val */
      validator: (val) => INPUT_POSITION_LIST.indexOf(val) !== -1,
    },
    iconPosition: {
      type: String,
      default: 'top-right',
      /** @param {string} val */
      validator: (val) => ICON_POSITION_LIST.indexOf(val) !== -1,
    },
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
      /** @param {string} val */
      validator: (val) => OPTION_SIZE_LIST.indexOf(val) !== -1,
    },
    description: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
    imageSrc: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconSize() {
      return ICON_SIZE_MAP[this.size];
    },
  },
};
</script>
